"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.server = exports.player = void 0;
const experience_1 = require("../experience");
const user_error_1 = __importDefault(require("../user_error"));
const player = function (player, serv) {
    player.xp = 0;
    player.displayXp = 0;
    player.xpLevel = 0;
    player.sendXp = () => {
        player._client.write('experience', {
            experienceBar: player.displayXp,
            level: player.level,
            totalExperience: player.xp
        });
    };
    player.setXpLevel = (level) => {
        player.xpLevel = level;
        player.sendXp();
    };
    player.setDisplayXp = () => {
        player.displayXp = Math.max(0, Math.min(1, player.displayXp));
        player.sendXp();
    };
    player.setXp = (xp, { setLevel = true, setDisplay = true, send = true } = {}) => {
        player.xp = xp;
        if (setLevel)
            player.level = (0, experience_1.getXpLevel)(xp);
        if (setDisplay)
            player.displayXp = (0, experience_1.distanceToXpLevel)(xp);
        if (send)
            player.sendXp();
    };
};
exports.player = player;
const server = function (serv) {
    serv.commands.add({
        base: 'xp',
        info: 'Give yourself experience',
        usage: '/xp <amount> [player] OR /xp <amount>L [player]',
        op: true,
        parse(str) {
            return str.match(/(-?\d+)(L)? ?([a-zA-Z0-9_]+)?/) || false;
        },
        action(args, ctx) {
            const isLevel = !!args[2];
            const amt = parseInt(args[1]);
            if (!ctx.player && !args[3])
                throw new user_error_1.default('Console can\'t give itself experience.');
            const user = args[3] ? serv.getPlayer(args[3]) : ctx.player;
            if (!user)
                throw new user_error_1.default(args[3] + ' is not on this server!');
            if (!isLevel) {
                user.setXp(user.xp + amt);
                if (ctx.player)
                    ctx.player.chat('Gave ' + user.username + ' ' + amt + ' xp');
                else
                    serv.info('Gave ' + user.username + ' ' + amt + ' xp');
            }
            else {
                const currLevel = (0, experience_1.getXpLevel)(user.xp);
                const baseCurrLevel = (0, experience_1.getBaseXpFromLevel)(currLevel);
                const extraXp = user.xp - baseCurrLevel;
                user.setXp((0, experience_1.getBaseXpFromLevel)(currLevel + amt) + extraXp);
                if (ctx.player)
                    ctx.player.chat('Gave ' + user.username + ' ' + amt + ' levels');
                else
                    serv.info('Gave ' + user.username + ' ' + amt + ' levels');
            }
        }
    });
};
exports.server = server;
